module.exports = {
      id: "chevron-down-usage",
      viewBox: "0 0 14 6.8",
      url: __webpack_public_path__ + "img/icons.488ce034.svg#chevron-down-usage",
      toString: function () {
        return this.url;
      }
    }